<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      <div class="space-y-2">
        <div class="flex space-x-2 select-none">
          <span>{{ reviewer.fullName }}</span>
          <a
            v-if="approvalRequest.comments.length"
            role="button"
            @click.prevent="showComments = !showComments"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
          </a>
        </div>
        <ul v-if="showComments" class="space-y-2">
          <li
            v-for="comment in approvalRequest.comments"
            :key="comment.uuid"
            class="bg-green-100 text-green-900 font-normal p-3 text-sm w-96 rounded border border-green-600 whitespace-normal"
          >
            {{ comment.content }}
          </li>
        </ul>
      </div>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      <span
        v-if="isApproved"
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
        >Approved</span
      >
      <span
        v-else-if="isRejected"
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
        >Rejected</span
      >
      <span
        v-else
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
        >Pending</span
      >
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ dateEmailSent }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ dateCreated }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      <div class="flex space-x-2">
        <BaseButton primary outline small @click="showEmailReviewersModal"> Send Email </BaseButton>
        <ApprovalRequestRevokeAction
          :project-asset-id="approvalRequest.approvableId"
          :approval-request-id="approvalRequest.id"
          @approval-request-revoked="$emit('approval-request-revoked')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import ApprovalRequestRevokeAction from 'Components/ProjectAssetApprovalRequests/ApprovalRequestRevokeAction.vue';

export default {
  components: {
    ApprovalRequestRevokeAction,
  },
  props: {
    approvalRequest: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showComments: false,
    };
  },
  computed: {
    reviewer() {
      return this.approvalRequest.user || { fullName: 'Missing reviewer' };
    },
    isApproved() {
      return typeof this.approvalRequest.approvedAt === 'string';
    },
    isRejected() {
      return typeof this.approvalRequest.rejectedAt === 'string';
    },
    dateEmailSent() {
      if (!this.approvalRequest.emailSentAt) {
        return '';
      }

      return moment(this.approvalRequest.emailSentAt).format('ddd D MMM Y');
    },
    dateCreated() {
      return moment(this.approvalRequest.createdAt).format('ddd D MMM Y');
    },
  },
  methods: {
    async showEmailReviewersModal() {
      this.$modal.show({
        component: () => import('Components/ProjectAssets/EmailReviewersModal.vue'),
        props: {
          project: this.project,
          defaultData: {
            to: [this.approvalRequest.userId],
          },
        },
        on: {
          'email-sent': () => {
            this.$emit('email-sent');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
